import axios from 'axios';

import {
  requestInterceptor,
  requestErrorInterceptor,
} from '../interceptors/requestInterceptors';
import {
  responseInterceptor,
  responseErrorInterceptor,
} from '../interceptors/responseInterceptors';

const baseURL = import.meta.env.VITE_REPORTS_URL;

const reportsApiAxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

reportsApiAxiosInstance.interceptors.request.use(
  (config) => requestInterceptor(config),
  requestErrorInterceptor
);

reportsApiAxiosInstance.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);

export { reportsApiAxiosInstance };
